










































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import GroupingPackageDetail from '@/store/entities/grouping-packages/grouping-package-detail';
import GroupingPackage from '@/store/entities/grouping-packages/grouping-package';
import _ from 'lodash';

class  PageUnitRequest extends PageRequest{
    keyword:string;
}

@Component({
    
})
export default class UpdateGroupingPackage extends AbpBase{
  namespace = 'deliveryPackageGroup';
  pagerequest:PageUnitRequest=new PageUnitRequest();
  code: string = "";
  grouping : GroupingPackage = new GroupingPackage();
  packages : GroupingPackageDetail[] = new Array<GroupingPackageDetail>();

  get loading(){
      return this.$store.state.deliveryPackageGroup.loading;
  }

  async getGroupongPackage(code){
    await this.$store
      .dispatch({
          type:`${this.namespace}/viewGroupingPackage`,
          data: { code : this.code}
      })
      .then(res => {
        this.grouping = res;
        this.packages = res.packages;
        this.onResetAndFocusInput();
      });
  }

  async onScan(){
        let code = this.pagerequest.keyword.trim();
        await this.$store.dispatch({
            type: `${this.namespace}/getInfoPackageToGroup`,
            data: { code: code }
        }).then((res) => {
                this.onResetAndFocusInput();
                if(this.grouping.aoGroupCode !== res.aoGroupCode || this.grouping.tplCode !== res.tplCode){
                    let msg = Util.L("Error.PackageIsNotFromTheSameTplAsThePreviousPackage");
                    msg = msg.replace('#0', code);
                    Util.showNoticeErrorMsg(this, msg);
                    return;
                }

                if(_.some(this.packages, {'packageId': res.packageId})){
                    Util.showNoticeErrorMsg(this,Util.L("Error.PackageAddedIntoTheGroup"));
                    return;
                }

              let infoPackage = new GroupingPackageDetail();
              infoPackage.packageId = res.packageId;
              infoPackage.soCode = res.soCode;
              infoPackage.packageCode = res.packageCode;
              infoPackage.externalCode = res.externalCode;
              this.packages.push(infoPackage);
              this.grouping.sumPackage = this.packages.length;
            }
            
        ).catch(() => {
          this.onResetAndFocusInput();
        });
    }

    onRemovePackage(packageId){
        if(this.packages.length === 1){
          Util.showNoticeErrorMsg(this, Util.L("Error.GroupPackageRequiredPackages"));
          return;
        }

        this.$Modal.confirm({
            title:this.L('Confirm'),
            content:this.L('Comfirm.RemovePackageOutGroup'),
            okText:this.L('Yes'),
            cancelText:this.L('No'),
            onOk: () => {
                this.packages = _.filter(this.packages, (x) => { return x.packageId != packageId });
                this.grouping.sumPackage = this.packages.length;
                if(this.grouping.sumPackage === 0){
                    this.grouping = new GroupingPackage();
                }
            }
        })
    }

    saveGroup(){
        this.$Modal.confirm({
            title:this.L('Confirm'),
            content:this.L('Comfirm.UpdateGroup'),
            okText:this.L('Yes'),
            cancelText:this.L('No'),
            onOk: async () => {
                await this.onSaveGroup();
            }
        });
    }

    async onSaveGroup(){
        var param = {
            groupingPackageCode: this.code,
            packageIds : _.map(this.packages, 'packageId')
        };
        await this.$store.dispatch({
            type: `${this.namespace}/createOrUpdateGroupingPackage`,
            data: param
        }).then((res) => {
            this.$root.$router.push({name: 'grouping-package/view/:code', params: {code: res}})
        });
    }

    onResetAndFocusInput(){
        (this.$refs.txtFirstInput as any).focus();
        this.$set(this.pagerequest, 'keyword', '');
    }

  onBack(){
      this.$router.push({name: 'grouping-package'});
  }

  packageColumns = [
    {
        title:Util.L('Order'),
        align: "center",
        slot: "order",
    },{
        title:Util.L('Package'),
        key:'packageCode'
    },{
        title:Util.L('SoCode'),
        key:'soCode'
    },{
        title:Util.L('ExternalCode'),
        key:'externalCode'
    },{
            title:Util.L('Action'),
            align: "center",
            slot: "action",
        }
  ];

  async created(){
    this.code = this.$root.$router.currentRoute.params.code;
    await this.getGroupongPackage(this.code);
  }
}
